import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/LanguageContext";
import { TextsProvider } from "@/TextsContext";
import LandingPage from "@/pages/LandingPage";
import EventDetailPage from "@/pages/EventDetailPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AdminPage from "@/pages/AdminPage";
import CancelPage from "@/pages/CancelPage";
import KarrierePage from "@/pages/KarrierePage";
import NewsletterConfirmPage from "@/pages/NewsletterConfirmPage";
import NewsletterUnsubscribePage from "@/pages/NewsletterUnsubscribePage";
import PageViewTracker from "@/components/PageViewTracker";

function App() {
  return (
    <LanguageProvider>
      <TextsProvider>
        <div className="App">
          <BrowserRouter>
            <PageViewTracker />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/veranstaltung/:id" element={<EventDetailPage />} />
              <Route path="/event/:id" element={<EventDetailPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/cancel" element={<CancelPage />} />
              <Route path="/karriere" element={<KarrierePage />} />
              <Route path="/newsletter/confirm" element={<NewsletterConfirmPage />} />
              <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribePage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </TextsProvider>
    </LanguageProvider>
  );
}

export default App;
